var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoIcon3 = function SvgLogoIcon3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 49,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EB008C",
    d: "M10.117.748A10.125 10.125 0 0 0 .015 10.873v19.375s15.437-10.386 17.272-12.22A10.125 10.125 0 0 0 10.133.747"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0000BE",
    d: "M20.235 38.538a10.118 10.118 0 1 1-10.118-10.117 10.125 10.125 0 0 1 10.118 10.117"
  })));
};
export default SvgLogoIcon3;